import type { FounderMonth, TodoItem, WeekData } from "./types";

/**
 * November 2026 founder schedule. Edit this file to change what the month
 * grid shows. Chips are derived from `weeks`, `dayExtras`, and the weekday
 * templates below. W45 周二观心 is EP14《红点堆着》／EP15《最终版》
 * （2026-11-03 自发表已发）. W45 周五观心短名已定：Fri-C《先加购》、
 * Fri-D《地图钉着》。旧题《标签页关不掉》《接龙还差你》整包作废。
 * 新题候一页纸／选题开写。
 *
 * Today and the default selected day are the wall-clock calendar day in
 * `timezone` (Asia/Shanghai). This file does not store a snapshot day.
 */

const pendingIp: WeekData["ip"] = [
  ["观心微语·二", "待锁"],
  ["观心微语·五", "待锁"],
  ["小凡的图文故事·三", "待锁"],
  ["小凡的图文故事·六", "待锁"],
  ["小凡的草稿本·日", "待锁"],
  ["小宇宙", "有料才带"],
];

function weekKeyNovember2026(y: number, m: number, d: number): string | null {
  if (y !== 2026) return null;
  if (m === 10) return "W44";
  if (m === 12) return "W49";
  if (m !== 11) return null;
  if (d === 1) return "W44";
  if (d >= 2 && d <= 8) return "W45";
  if (d >= 9 && d <= 15) return "W46";
  if (d >= 16 && d <= 22) return "W47";
  if (d >= 23 && d <= 29) return "W48";
  if (d === 30) return "W49";
  return null;
}

const dayExtras: Record<number, TodoItem[]> = {
  2: [
    { tag: "you", text: "本周计划＋锁题／周历已定并窗（主闸已过）" },
    { tag: "ip", text: "开产观心微语周二《红点堆着》《最终版》已发" },
    { tag: "co", text: "账号数据≈09:15 · Skill≈10:00" },
  ],
  3: [
    {
      tag: "you",
      text: "观心微语《红点堆着》《最终版》已发（2026-11-03 自发表）",
    },
    { tag: "ip", text: "开小凡的图文故事周三《借着天凉》备货" },
  ],
  4: [
    {
      tag: "you",
      text: "小凡的图文故事《借着天凉》扫＋ship（文案包曾报 12 页 vs 锁 6–9，裁切／暂压以当场为准）",
    },
    { tag: "ip", text: "开周五观心；周六件并行备货" },
  ],
  5: [
    {
      tag: "you",
      text: "周末件前置审：六《字条和277块》＋日《「纯过日子」到底赢在哪》",
    },
    { tag: "ip", text: "周五观心闸门收口" },
    { tag: "co", text: "用量重置约 11:35 Asia/Shanghai" },
  ],
  6: [
    {
      tag: "you",
      text: "观心微语《先加购》《地图钉着》选题开写（候一页纸）",
    },
    { tag: "you", text: "统一定时：六图文／日草稿（过审未定时＝未收口）" },
    { tag: "talk", text: "≈17:45 周报并窗" },
  ],
  7: [
    { tag: "ip", text: "定时出《字条和277块》（抖＋红）" },
    { tag: "soft", text: "默跑／无内容交流" },
  ],
  8: [
    { tag: "ip", text: "定时出草稿《「纯过日子」到底赢在哪》" },
    { tag: "ip", text: "≈17:00 下周选题草案（不定稿，可拖周一）" },
    { tag: "soft", text: "默跑／无内容交流" },
  ],
};

export const november2026: FounderMonth = {
  id: "2026-11",
  title: "2026年11月",
  refreshed: "2026-11-04T10:10:00+08:00",
  timezone: "Asia/Shanghai",
  weekKey: weekKeyNovember2026,
  dayExtrasWeek: "W45",
  dayExtras,
  weeks: {
    W44: {
      label: "W44",
      range: "10/26–11/01",
      inMonth: "本月仅 11/01（日）",
      status: "past",
      statusText: "过去",
      ip: [
        ["观心微语", "《别在意》已发 · 《以为懂了》已 ship"],
        ["小凡的图文故事", "《钥匙》·《按住说话》（抖＋红，已 ship）"],
        ["小凡的草稿本", "041《我翻了 3 年前的备忘录》（已发）"],
        ["小宇宙", "空档／未开"],
      ],
      co: "官网 v3.2 挂 haoli.xblz.org · GEO 可见产出齐 · FH-015 锁 · 接单本周不开 · 事项看板基本收口",
      marks: { ip: true, you: false, co: true, empty: false },
      progress: false,
    },
    W45: {
      label: "W45",
      range: "11/02–11/08",
      inMonth: "整周",
      status: "now",
      statusText: "本周",
      ip: [
        ["观心微语·二", "《红点堆着》《最终版》已发"],
        ["观心微语·五", "《先加购》《地图钉着》"],
        ["小凡的图文故事·三", "《借着天凉》"],
        ["小凡的图文故事·六", "《字条和277块》"],
        ["小凡的草稿本·日", "《「纯过日子」到底赢在哪》"],
        ["小宇宙", "本周不带"],
        ["余料", "《楼下两元店没了》进草稿箱未发"],
      ],
      co: "稳态开跑 · 总／专历 11-02d · GEO 首批 assets＋双站 audit · Atomic CRM 相对更新 · 侧栏待删岗空档手删 · 用量重置约 11/5 11:35",
      marks: { ip: true, you: true, co: true, empty: false },
      progress: true,
    },
    W46: {
      label: "W46",
      range: "11/09–11/15",
      inMonth: "整周",
      status: "future",
      statusText: "未来",
      ip: [...pendingIp, ["打工牛马连连看", "调研进行中·六条思路备忘"]],
      co: "引用与跟跑 · GEO 可引用稿加跑／过程目标 ≥2 引擎 named · CosyTab 周复盘短报",
      marks: { ip: false, you: true, co: true, empty: true },
      progress: false,
    },
    W47: {
      label: "W47",
      range: "11/16–11/22",
      inMonth: "整周",
      status: "future",
      statusText: "未来",
      ip: pendingIp,
      co: "GEO 验收窗 · Phase A 四周判定入对内周报 · 不升 Phase B 除非 L3 · 个人IP 照常 · 控用量并行",
      marks: { ip: false, you: true, co: true, empty: true },
      progress: false,
    },
    W48: {
      label: "W48",
      range: "11/23–11/29",
      inMonth: "整周",
      status: "future",
      statusText: "未来",
      ip: pendingIp,
      co: "巩固与月尾 · GEO 按 W47 判定 ≤5 优化 · Atomic CRM 月末商机一行 · 月报素材预备（28–31 窗）",
      marks: { ip: false, you: true, co: true, empty: true },
      progress: false,
    },
    W49: {
      label: "W49",
      range: "11/30 起",
      inMonth: "本月仅 11/30（一）",
      status: "future",
      statusText: "缓冲",
      ip: [["—", "非本月主产周；周一缓冲"]],
      co: "为 12 月周计划备货 · 非 L3 不扰周末前夜",
      marks: { ip: false, you: false, co: true, empty: true },
      progress: false,
    },
  },
  kayouByDow: {
    1: {
      win: "≈08:30–11:00",
      title: "锁主题并窗",
      items: [
        { tag: "talk", text: "≈08:30 日计划 · ≈08:40 周工作计划（周一）" },
        {
          tag: "you",
          text: "交流：锁本周主题（观心4＋图文2＋草稿1；小宇宙有料才带）",
        },
        { tag: "talk", text: "≈17:30 日报（扫需拍板；无则跳）" },
      ],
    },
    2: {
      win: "成片窗",
      title: "观心审美＋ship",
      items: [
        { tag: "talk", text: "≈08:30 日计划" },
        { tag: "you", text: "交流：观心微语 ×2 审美＋点名 ship" },
        { tag: "talk", text: "≈17:30 日报" },
      ],
    },
    3: {
      win: "发布窗",
      title: "图文工作日件",
      items: [
        { tag: "talk", text: "≈08:30 日计划" },
        { tag: "you", text: "交流：小凡的图文故事 ×1 组扫＋ship（抖＋红）" },
        { tag: "talk", text: "≈17:30 日报" },
      ],
    },
    4: {
      win: "前置审窗",
      title: "周末件前置审",
      items: [
        { tag: "talk", text: "≈08:30 日计划 · ≈17:30 日报" },
        {
          tag: "you",
          text: "交流：周末件前置审（六图文组＋日草稿篇）；未齐→最迟周五上午补审",
        },
      ],
    },
    5: {
      win: "成片＋定时闸",
      title: "观心＋统一定时＋周报",
      items: [
        { tag: "talk", text: "≈08:30 日计划" },
        { tag: "you", text: "交流：观心微语 ×2 审美＋ship" },
        {
          tag: "you",
          text: "交流：统一定时闸（六图文／日草稿；你在平台点／确认；禁代设定时冒充已发）",
        },
        { tag: "talk", text: "≈17:30 日报 · ≈17:45 周报并窗" },
      ],
    },
    6: {
      win: "默认无",
      title: "定时出图文",
      items: [
        {
          tag: "soft",
          text: "默认无内容交流 · 定时自动发 · 仅异常／红灯才扰",
        },
      ],
    },
    0: {
      win: "默认无",
      title: "定时出草稿＋草案",
      items: [
        { tag: "soft", text: "默认无内容交流 · 草稿定时出 · 仅异常才扰" },
        { tag: "ip", text: "≈17:00 下周选题草案（不定稿；可拖周一）" },
      ],
    },
  },
  ipByDow: {
    1: "定稿后开周二观心微语整片备货（岗内）",
    2: "发布日：观心微语双发；同步开周三图文备货",
    3: "发布日：小凡的图文故事 1 组双端；开周五观心备货；周末件并行至周四审包",
    4: "备货＋审包：周五观心闸门；周六图文／周日草稿审包交齐",
    5: "发布日＋定时：观心双发；六／日平台定时就位",
    6: "发布日·定时：小凡的图文故事 1 组（周五已定时）",
    0: "发布日·定时：小凡的草稿本 1 篇；小宇宙有料插空；CosyTab 不占",
  },
  coByDow: {
    1: "产线 Skill≈10:00 · Atomic CRM · GEO 双案 · 岗间巡检 · 邮箱 9/13/17 · 编制≈18:30",
    2: "CRM／GEO／双站 audit／邮箱／岗间／编制≈18:30（默跑）",
    3: "工作日默跑套餐；红灯才升",
    4: "默跑；GEO 周结论草稿可成型（进周五周报）",
    5: "GEO 周结论进周报 · CRM 周内收口 · 编制≈18:30",
    6: "编制≈18:30（含周末；无漂静默）· CRM／岗间工作日满跑",
    0: "编制≈18:30 · 周循环收口检查（岗内）",
  },
  deferred: [
    "工商主体注册与 haoli.net.cn 单位备案（等启动金）",
    "接外客 Phase B；接单平台开号（未拍板前不开）",
    "旧 Canvas dens 新期；CEO 代流程岗跑工具通道",
    "代发／代设定时冒充已发",
  ],
  goals: [
    {
      domain: "观心微语",
      goal: "合集稳态双发日；周产 4",
      check: "二／五各 2 条点名 ship；闸门包流水",
    },
    {
      domain: "小凡的图文故事",
      goal: "三六各 1 组（抖＋红）",
      check: "FH-015；6–9 页；禁代发",
    },
    {
      domain: "小凡的草稿本",
      goal: "周日 1 篇",
      check: "API→草稿箱→人手／周五定时；禁代群发",
    },
    {
      domain: "小宇宙",
      goal: "EP01《正念的奇迹》上线优先",
      check: "自录＋自贴后制作；禁代贴",
    },
    {
      domain: "GEO",
      goal: "Phase A 双案跑满 W45–W47",
      check: "W47 验收：≥3 引擎正确点名且可核；未达标不编造；不接外客",
    },
    {
      domain: "工作台",
      goal: "Atomic CRM 日常跟进真源",
      check: "商机／Tasks／备注相对更新；Notion 仅长文旁路",
    },
    {
      domain: "编制·例行",
      goal: "章称稳态；侧栏待删清",
      check: "日检≈18:30；无漂不扰",
    },
  ],
  cadence:
    "发布日频率：观心微语 周二／五各双发 · 小凡的图文故事 周三／六各 1 组 · 小凡的草稿本 周日 1 篇 · CosyTab 不占产能 · 小宇宙慢更／有料才带。",
  changes: [
    { date: "2026-11-02", text: "月安排骨架 → 月主视图合一页。" },
    {
      date: "2026-11-02",
      text: "据创始人「周内容夹在本周／下周行间折叠展开；优化周表；点日出 todo；月主／周辅／日具体」——本页交互刷新。",
    },
    {
      date: "2026-11-02",
      text: "周期点从「日」改为「一」（周一开头），行切分／夹层与 ISO 周对齐。",
    },
    {
      date: "2026-11-02",
      text: "月格短条 chip＋点条弹层；点空白展夹层且跟日过滤；「看整周」回三栏全貌（痛点：换日周内容几乎不变只刷 todo）。",
    },
    {
      date: "2026-11-03",
      text: "观心微语周二双发已发：EP14《红点堆着》、EP15《最终版》自发表。",
    },
    {
      date: "2026-11-04",
      text: "打卡连连看升正式业务线「打工牛马连连看」（biz.niuma／nm，实心）。W45 11/04 与 W46 周条挂调研进行中·六条思路备忘。真源 ops/products/打工牛马连连看/思路备忘-2026-11-04.md · deal-3 · Tasks#17。",
    },
    {
      date: "2026-11-04",
      text: "观心微语 W45 周五双发改挂短名 Fri-C《先加购》、Fri-D《地图钉着》。旧题《标签页关不掉》《接龙还差你》整包作废。新题候一页纸／选题开写。",
    },
  ],
  progressNote:
    "P0 回写观心 W45 Tue artifacts：口播全文＋飞书静帧／成片链（旧题作废、现网已发）。Fri 短名《先加购》《地图钉着》已定，候一页纸／选题开写；旧题整包作废。",
  progressHeaders: [
    "业务／条",
    "选题",
    "文案／口播",
    "闸门",
    "制作",
    "审美／过审",
    "定时／发布",
    "备注",
  ],
  progressRows: [
    {
      title: "观心微语 · 周二",
      subtitle: "《红点堆着》《最终版》",
      cells: ["✓", "口播 PASS", "制作文本 PASS", "已发", "已发", "已发"],
      note: "已发·禁代发",
      artifacts: {
        选题: {
          kind: "text",
          title: "W45 周二双发 · 已发",
          body: "EP14《红点堆着》、EP15《最终版》：2026-11-03 自发表已发。\n作废旧题（未发）：A《免打扰开着》：免打扰开着≠真下线，多半怕被看见「还在」。\nB《稍等》：「稍等」像在准备回复，其实先按住催促，后面常没时间点。",
        },
        "文案／口播": {
          kind: "text",
          title: "口播定稿全文（旧题作废）",
          body: "作废：以下为未发旧题《免打扰开着》《稍等》口播，不是已发 EP14《红点堆着》／EP15《最终版》。\n\n【Tue-A《免打扰开着》】\n手指往上一拨。免打扰开了。开关亮起来。工作群的名字灰下去，铃铛上划了一道斜杠。拨完你还停了一下。看着像下线了。其实没有。列表还在轻轻往下滑。你拇指一顿一顿地过。新消息顶上来，你还是瞄一眼——只是不点进去。标题扫过了，内容没开。群还在那儿跳。你装作没看见。不是不想看。是不想被当成随时都能叫你的人。你还在线。只是不想被叫。手机还捏在手里。群名灰着，铃上还挂着斜杠，你人还在刷。刷的是列表，不是回人。开关开着，别人以为你不在。你知道自己还在。只是不想被看见「在」。你借这个开关装了个下线。给自己留一口气。免打扰是真开着。下线，是装的。\n\n【Tue-B《稍等》】\n「稍等」已经发出去了。对方催的那句，像被接住了。像马上有下文。对话框安静下来。你以为自己马上就会回正事。屏幕亮着，输入框空着。光标闪了两下，又灭了。手指搁在键盘上，又拿开。过了一会儿——没有「十分钟后」。也没有「今晚再说」。气泡后面空着，时间点一个都没写。半晌没人再说话。对方那边还等着，以为你在准备。你这边呢，其实也没排上。球就停在半空，谁也没接着。聊天还开着。正事一点都没动。过一阵对方又冒一句：好了吗？你还是那两个字。稍等。像有了下文。其实还是停着。回了「稍等」是真的。开始回复，没有。那俩字只是先把催促按住了。不是开始回复。",
        },
        闸门: {
          kind: "text",
          title: "制作文本／闸门",
          body: "现网 EP14《红点堆着》EP15《最终版》已发。作废旧题《免打扰开着》《稍等》闸门记录：口播闸 PASS · 制作文本（含重选型）PASS · 密度分镜 v2 dens PASS · 静帧 dens 抽帧双 PASS · 成片 dens 双 PASS · 总闸已交呈。禁代发。",
        },
        制作: {
          kind: "links",
          title: "作废 · 旧题密度 v2 静帧／成片（飞书）",
          body: "作废：旧题《免打扰开着》《稍等》静帧／成片夹。现网周二已发为 EP14《红点堆着》EP15《最终版》。",
          links: [
            {
              label: "作废 · 静帧密度v2 A《免打扰开着》",
              url: "https://my.feishu.cn/drive/folder/Lg7bfq8JWlzEvIdcGZbc1ZJJnLg",
            },
            {
              label: "作废 · 静帧密度v2 B《稍等》",
              url: "https://my.feishu.cn/drive/folder/C0d7fQuYul3Xo4dTPOAcn2g7nYe",
            },
            {
              label: "作废 · 成片夹 A《免打扰开着》",
              url: "https://my.feishu.cn/drive/folder/XTnMf2Ybll2iQPdxmwCcyPUon6d",
            },
            {
              label: "作废 · 成片夹 B《稍等》",
              url: "https://my.feishu.cn/drive/folder/Oun3fK40Vl7GNMdLfHccma4ynDg",
            },
          ],
        },
        "审美／过审": {
          kind: "links",
          title: "作废 · 旧题审美／dens／总闸",
          body: "作废：旧题《免打扰开着》《稍等》静帧审美双过；成片 dens 双 PASS（空段0）；总闸已交呈。现网周二已发。禁代发。",
          links: [
            {
              label: "作废 · 成片夹 A《免打扰开着》",
              url: "https://my.feishu.cn/drive/folder/XTnMf2Ybll2iQPdxmwCcyPUon6d",
            },
            {
              label: "作废 · 成片夹 B《稍等》",
              url: "https://my.feishu.cn/drive/folder/Oun3fK40Vl7GNMdLfHccma4ynDg",
            },
          ],
        },
        "定时／发布": {
          kind: "links",
          title: "已发·禁代发",
          body: "已发·禁代发。EP14《红点堆着》EP15《最终版》2026-11-03 自发表。旧《免打扰开着》《稍等》成片夹作废。",
          links: [
            {
              label: "作废 · 成片夹 A《免打扰开着》",
              url: "https://my.feishu.cn/drive/folder/XTnMf2Ybll2iQPdxmwCcyPUon6d",
            },
            {
              label: "作废 · 成片夹 B《稍等》",
              url: "https://my.feishu.cn/drive/folder/Oun3fK40Vl7GNMdLfHccma4ynDg",
            },
          ],
        },
      },
    },
    {
      title: "观心微语 · 周五",
      subtitle: "《先加购》《地图钉着》",
      cells: ["选题开写", "候一页纸", "—", "—", "—", "—"],
      note: "短名已定。Fri-C《先加购》替《标签页关不掉》，Fri-D《地图钉着》替《接龙还差你》。新题候一页纸／选题开写。旧题整包作废。",
      artifacts: {
        选题: {
          kind: "text",
          title: "短名已定 · 候一页纸",
          body: "短名已定，选题开写。Fri-C《先加购》替旧题《标签页关不掉》；Fri-D《地图钉着》替旧题《接龙还差你》。\n新题候一页纸。旧题整包作废：口播、静帧与制作链不再沿用。",
        },
        "文案／口播": {
          kind: "text",
          title: "候一页纸",
          body: "新题《先加购》《地图钉着》尚无口播。旧题《标签页关不掉》《接龙还差你》口播整包作废。",
        },
        闸门: {
          kind: "text",
          title: "旧题整包作废",
          body: "旧题整包作废。新题未开写闸门。",
        },
        制作: {
          kind: "text",
          title: "旧题整包作废",
          body: "旧题整包作废。新题未开写制作。",
        },
        "审美／过审": {
          kind: "text",
          title: "旧题整包作废",
          body: "旧题整包作废。新题未开写审美。",
        },
        "定时／发布": {
          kind: "text",
          title: "旧题整包作废",
          body: "旧题整包作废。新题未排发布。",
        },
      },
    },
    {
      title: "小凡的图文故事 · 周三",
      subtitle: "《借着天凉》",
      cells: [
        "✓",
        "文案包 CEO 软过\n（12页 vs 锁6–9）",
        "待过闸",
        "出图待过闸",
        "—",
        "周三 ship 窗",
      ],
      note: "FH-015；裁切／暂压以当场为准",
      artifacts: {
        选题: { kind: "text", title: "锁题", body: "《借着天凉》" },
        "文案／口播": {
          kind: "text",
          title: "文案",
          body: "文案包 CEO 软过（12页 vs 锁6–9）",
        },
        制作: { kind: "links", title: "制作", links: [] },
      },
    },
    {
      title: "小凡的图文故事 · 周六",
      subtitle: "《字条和277块》",
      cells: ["✓", "计划周四交审", "—", "—", "—", "周五定时→周六发"],
      note: "周末件",
    },
    {
      title: "小凡的草稿本 · 周日",
      subtitle: "《「纯过日子」到底赢在哪》",
      cells: ["✓", "成稿 CEO 软过", "—", "—", "待你过眼", "周五定时→周日发"],
      note: "禁代发",
    },
    {
      title: "草稿本余料",
      subtitle: "《楼下两元店没了》",
      cells: ["—", "✓", "—", "—", "—", "已进草稿箱（未发）"],
      note: "非本周日正选",
    },
    { title: "小宇宙", span: "本周不带", note: "" },
    { title: "CosyTab", span: "默跑", note: "" },
  ],
  sources:
    "文字真源 ops/FOUNDER_MONTHLY_CALENDAR.md · 周细看总周历 · 禁代发 · 本页静态数据见 november2026.ts",
};
